import { PageSection, Product } from '../types';

/** Bästsäljare visar 3–6 produkter; 3 fyller en rad på dator. */
export const SHOWCASE_MIN = 3;
export const SHOWCASE_MAX = 6;
export const showcaseLimit = (section: Pick<PageSection, 'productLimit'>): number =>
    Math.min(SHOWCASE_MAX, Math.max(SHOWCASE_MIN, Math.round(section.productLimit ?? SHOWCASE_MIN)));

/**
 * Vilka produkter Bästsäljare visar, i ordning.
 *
 * - Välj själv: admins produkter i admins ordning. Borttagna produkter hoppas över.
 * - Mest sålda: de mest sålda senaste 30 dagarna. Har för få sålts fylls
 *   raden på med admins val och sedan resten av sortimentet, så att
 *   sektionen aldrig står halvtom.
 * - En äldre sektion utan val visar de första produkterna, som förut.
 */
export const pickShowcaseProducts = (
    products: Product[],
    section: Pick<PageSection, 'productIds' | 'productSource' | 'productLimit'>,
    bestsellingIds: string[] = [],
): Product[] => {
    const limit = showcaseLimit(section);
    const byId = new Map(products.map(p => [p.id, p]));
    const chosen = (section.productIds || []).filter(id => byId.has(id));
    const order = section.productSource === 'bestselling'
        ? [...bestsellingIds, ...chosen, ...products.map(p => p.id)]
        : chosen.length > 0 ? chosen : products.map(p => p.id);
    const seen = new Set<string>();
    const out: Product[] = [];
    for (const id of order) {
        const p = byId.get(id);
        if (!p || seen.has(id)) continue;
        seen.add(id);
        out.push(p);
        if (out.length === limit) break;
    }
    return out;
};
